<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Part Good Receipt" active>

                                <b-row v-if="hasFailedDataPartGoodReceipt">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPartGoodReceipt.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partGoodReceiptsFailed" :fields="fieldsPartGoodReceipt" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartGoodReceipt" :sort-desc.sync="sortDescPartGoodReceipt" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(partGoodReceiptDate)="row">
													{{ row.item.partGoodReceiptDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPartGoodReceipt.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partGoodReceipts" :fields="fieldsPartGoodReceipt" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartGoodReceipt" :sort-desc.sync="sortDescPartGoodReceipt" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(partGoodReceiptDate)="row">
													{{ row.item.partGoodReceiptDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Part Good Receipt Detail" active>

                                <b-row v-if="hasFailedDataPartGoodReceiptDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPartGoodReceiptDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partGoodReceiptDetailsFailed" :fields="fieldsPartGoodReceiptDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartGoodReceiptDetail" :sort-desc.sync="sortDescPartGoodReceiptDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyOutstandingBefore)="row">
													{{ Number(row.item.qtyOutstandingBefore).toLocaleString() }}
												</template>
												<template #cell(qtyReceived)="row">
													{{ Number(row.item.qtyReceived).toLocaleString() }}
												</template>
												<template #cell(qtyActual)="row">
													{{ Number(row.item.qtyActual).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPartGoodReceiptDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partGoodReceiptDetails" :fields="fieldsPartGoodReceiptDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartGoodReceiptDetail" :sort-desc.sync="sortDescPartGoodReceiptDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyOutstandingBefore)="row">
													{{ Number(row.item.qtyOutstandingBefore).toLocaleString() }}
												</template>
												<template #cell(qtyReceived)="row">
													{{ Number(row.item.qtyReceived).toLocaleString() }}
												</template>
												<template #cell(qtyActual)="row">
													{{ Number(row.item.qtyActual).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
                            <b-tab title="Upload Part Good Receipt Case" active>

                                <b-row v-if="hasFailedDataPartGoodReceiptCase">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPartGoodReceiptCase.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partGoodReceiptCasesFailed" :fields="fieldsPartGoodReceiptCase" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartGoodReceiptCase" :sort-desc.sync="sortDescPartGoodReceiptCase" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyReceive)="row">
													{{ Number(row.item.qtyReceive).toLocaleString() }}
												</template>
												<template #cell(qtyAdjustment)="row">
													{{ Number(row.item.qtyAdjustment).toLocaleString() }}
												</template>
												<template #cell(qtyActual)="row">
													{{ Number(row.item.qtyActual).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPartGoodReceiptCase.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partGoodReceiptCases" :fields="fieldsPartGoodReceiptCase" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartGoodReceiptCase" :sort-desc.sync="sortDescPartGoodReceiptCase" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyReceive)="row">
													{{ Number(row.item.qtyReceive).toLocaleString() }}
												</template>
												<template #cell(qtyAdjustment)="row">
													{{ Number(row.item.qtyAdjustment).toLocaleString() }}
												</template>
												<template #cell(qtyActual)="row">
													{{ Number(row.item.qtyActual).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import PartGoodReceipt from '@/models/PartGoodReceipt/PartGoodReceipt';
import PartGoodReceiptList from '@/models/PartGoodReceipt/PartGoodReceiptList';
import PartGoodReceiptFilter from '@/filters/PartGoodReceipt/PartGoodReceiptFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsPartGoodReceipt: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Purchase Order", key: 'purchaseOrderPurchaseOrderNumber', sortable: false},
				{"class" : "th-status", "label" : "Part Good Receipt Date", key: 'partGoodReceiptDate', sortable: false},
				{"class" : "th-status", "label" : "Surat Jalan", key: 'suratJalan', sortable: false},
				{"class" : "th-status", "label" : "Remark", key: 'remark', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPartGoodReceiptDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Purchase Order Detail Id", key: 'purchaseOrderDetailQtyPo', sortable: false},
				{"class" : "th-status", "label" : "Part Code", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Outstanding Before", key: 'qtyOutstandingBefore', sortable: false},
				{"class" : "th-status", "label" : "Qty Received", key: 'qtyReceived', sortable: false},
				{"class" : "th-status", "label" : "Qty Actual", key: 'qtyActual', sortable: false},
				{"class" : "th-status", "label" : "Qty Outstanding After", key: 'qtyOutstandingAfter', sortable: false},
				{"class" : "th-status", "label" : "Remark", key: 'remark', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPartGoodReceiptCase: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Purchase Order Detail", key: 'purchaseOrderDetailQtyPo', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Supplier Case Number", key: 'supplierCaseNumber', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Receive", key: 'qtyReceive', sortable: false},
				{"class" : "th-status", "label" : "Qty Adjustment", key: 'qtyAdjustment', sortable: false},
				{"class" : "th-status", "label" : "Qty Actual", key: 'qtyActual', sortable: false},
				{"class" : "th-status", "label" : "Remark", key: 'remark', sortable: false},
				{"class" : "th-status", "label" : "Part Good Receipt Detail", key: 'partGoodReceiptDetailPart', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			partGoodReceipts : [],
			partGoodReceiptsFailed: [],
			partGoodReceiptId : '',
			sortByPartGoodReceipt: '',
			sortDescPartGoodReceipt: '',
			hasFailedDataPartGoodReceipt: false,
			totalFailedPartGoodReceipt: 0,
			totalSucceedPartGoodReceipt: 0,
			partGoodReceiptDetails : [],
			partGoodReceiptDetailsFailed: [],
			partGoodReceiptDetailId : '',
			sortByPartGoodReceiptDetail: '',
			sortDescPartGoodReceiptDetail: '',
			hasFailedDataPartGoodReceiptDetail: false,
			totalFailedPartGoodReceiptDetail: 0,
			totalSucceedPartGoodReceiptDetail: 0,

			partGoodReceiptCases : [],
			partGoodReceiptCasesFailed: [],
			partGoodReceiptCaseId : '',
			sortByPartGoodReceiptCase: '',
			sortDescPartGoodReceiptCase: '',
			hasFailedDataPartGoodReceiptCase: false,
			totalFailedPartGoodReceiptCase: 0,
			totalSucceedPartGoodReceiptCase: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('partgoodreceipt/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('partgoodreceipt/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getPartGoodReceiptForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getPartGoodReceiptForUpload : async function() {
			let _this = this;
			this.$http.get('partgoodreceipt/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.partGoodReceipts = [];
_this.partGoodReceiptDetails = [];
_this.partGoodReceiptCases = [];


					if (response != null) {
						let result = response.data;
						_this.partGoodReceipts = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedPartGoodReceipt = _this.partGoodReceipts.length;

						_this.partGoodReceiptsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataPartGoodReceipt = true;
						_this.totalFailedPartGoodReceipt = 0;
						if(_this.partGoodReceiptsFailed == undefined || _this.partGoodReceiptsFailed.length === 0) _this.hasFailedDataPartGoodReceipt = false;
						if(_this.hasFailedDataPartGoodReceipt) _this.totalFailedPartGoodReceipt = _this.partGoodReceiptsFailed.length;
						_this.partGoodReceiptDetails = [];
						_this.partGoodReceiptDetailsFailed = [];
						_this.hasFailedDataPartGoodReceiptDetail = true;
						_this.totalSucceedPartGoodReceiptDetail = 0;
						result.forEach(function(element) {
							_this.partGoodReceiptDetails.push(...element.partGoodReceiptDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPartGoodReceiptDetail = _this.partGoodReceiptDetails.length;

							_this.partGoodReceiptDetailsFailed.push(...element.partGoodReceiptDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.partGoodReceiptDetailsFailed == undefined || _this.partGoodReceiptDetailsFailed.length === 0) _this.hasFailedDataPartGoodReceiptDetail = false;
							if(_this.hasFailedDataPartGoodReceiptDetail) _this.totalFailedPartGoodReceiptDetail = _this.partGoodReceiptDetailsFailed.length;
						});						_this.partGoodReceiptCases = [];
						_this.partGoodReceiptCasesFailed = [];
						_this.hasFailedDataPartGoodReceiptCase = true;
						_this.totalSucceedPartGoodReceiptCase = 0;
						result.forEach(function(element) {
							_this.partGoodReceiptCases.push(...element.partGoodReceiptCase.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPartGoodReceiptCase = _this.partGoodReceiptCases.length;

							_this.partGoodReceiptCasesFailed.push(...element.partGoodReceiptCase.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.partGoodReceiptCasesFailed == undefined || _this.partGoodReceiptCasesFailed.length === 0) _this.hasFailedDataPartGoodReceiptCase = false;
							if(_this.hasFailedDataPartGoodReceiptCase) _this.totalFailedPartGoodReceiptCase = _this.partGoodReceiptCasesFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'partgoodreceipt/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'PartGoodReceipt.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterPartGoodReceipt = new PartGoodReceiptFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
